import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'div',
    'documentCardActions',
    'documentsGrid'
)`
    ${propStyles};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 16px;
    &:first-of-type {
        border-bottom: 1px solid #dee2e6;
        margin: 16px 16px 0 16px;
        padding: 0 0 16px 0;
    }
`;

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentCardActions.tsx